// Chakra imports
import {
  Heading,
  Box,
  SimpleGrid,
  Text,
  HStack,
  VStack,
  Icon,
  Button,
  Card,
  Flex,
  useColorModeValue,
  Select,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  InputGroup,
  InputLeftAddon,
  Input,
  PinInput,
  PinInputField,
  useOutsideClick,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import { downloadExcel } from "react-export-table-to-excel";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { TimePicker } from "antd";
import TimeInput from "material-ui-time-picker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { RadialChart } from "react-vis";
import { BlobServiceClient } from "@azure/storage-blob";
import {
  FiSunrise,
  FiSunset,
  FiPhoneOff,
  FiCalendar,
  FiDownload,
  FiUpload,
  FiGlobe,
  FiUser,
} from "react-icons/fi";
import { React, useEffect, useState, useRef } from "react";
import MiniCalendar from "components/calendar/MiniCalendar";
import InitiateCallTable from "./components/InitiateCallTable";
import EditGlobalConfig from "./components/EditGlobalConfig";
import "./initiateCall.css";
import { s_time, tableData, columnName, wfDetails } from "./dataset";
import {
  putCSVFileInBlob,
  postOTPToUser,
  closeOTPModal,
  verifyOTPWithUser,
  getFilesData,
  updateScheduleCallTimeAction,
  stopCurrentCallAction,
  fetchGlobalConfigsAction,
  updateGlobalConfigsAction,
  updateStopCallAction,
  setModalForStopCallAction,
  disableFileAction,
} from "../../../redux/actions/initiateCall";
import Loader from "components/loader";
import ClipLoader from "react-spinners/ClipLoader";
import { useDispatch, useSelector } from "react-redux";
import InitiateCallCalender from "./components/Calender";
import moment from "moment";
import InitiateCallDateTimePicker from "./components/DateTimePicker";
import {
  getBlobStorageDetails,
  callStatusFromFileId,
  exportReinitiateCallList,
} from "../../../redux/agent";
import ProgressBar from "@ramonak/react-progress-bar";
const UTC_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSS[Z]";
const callBlockStartTime = "15:15";
const callBlockEndTime = "02:30";
export default function InitiateCall() {
  let analyticsData = [];
  let fileRef = useRef();
  const calenderRef = useRef();
  let dispatch = useDispatch();
  let todayDateRange = {
    startDate: moment()
      .utc()
      .set({ hours: "0", minutes: "0", seconds: "0" })
      .format(UTC_DATE_TIME_FORMAT),
    endDate: moment().utc().format(UTC_DATE_TIME_FORMAT),
  };
  useOutsideClick({
    ref: calenderRef,
    handler: () => {
      setSelectedButton((state) => {
        return { ...state, isCustom: false };
      });
    },
  });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [fileDetails, setFileDetails] = useState({
    name: "Not selected",
    updatedName: null,
  });
  const [csvFile, setcsvFile] = useState(null);
  const [showFileUploadModal, setShowFileUploadModal] = useState(false);
  const [showEditCallTimeModal, setShowEditCallTimeModal] = useState(false);
  const [dateFromCalender, setDateFromCalender] = useState(new Date());
  const [openMiniCalender, setOpenMiniCalender] = useState(false);
  const [otpValue, setOTPValue] = useState("");
  const [selectedWorkFlow, setSelectedWorkFlow] = useState(wfDetails[0]);
  const [tableData, setTableData] = useState([]);
  const [modalCallReinitiation, setModalCallReInitiation] = useState(false);
  const userState = useSelector((state) => state.userData);
  const [selectedButton, setSelectedButton] = useState({
    isToday: true,
    is7days: false,
    is30Days: false,
    isCustom: false,
  });
  const [selectedDateRange, setSelectedDateRange] = useState(todayDateRange);
  const [selectedRowTosetCllTime, setselectedRowTosetCllTime] = useState();
  const [scheduleCallTiming, setScheduleCallTiming] = useState({
    date: new Date(),
    time: new Date(),
    dateAndTime: "",
  });
  const [submitAfterWhichFlow, setSubmitAfterWhichFlow] = useState({
    isStartCallNow: false,
    isScheduledCall: false,
  });
  const [scheduledCallPayloadData, setScheduledCallPayloadData] =
    useState(null);

  const [stopCallWorkFlowId, setStopCallWorkFlowId] = useState("P0001");
  const [popupForDisableFile, setPopupForDisableFile] = useState(false);
  const [selectedFileToDisable, setSelectedFileToDisable] = useState(null);
  const [popupForBatchDetails, setPopUpForBatchDetails] = useState(false);
  const [selectedBatchDetails, setselectedBatchDetails] = useState(null);
  const [batchDetailsFromInterFace, setBatchDetailsFromInterFace] =
    useState(null);
  const [liveCallFetchInterValId, setLiveCallFetchInterValId] = useState("");
  const [popupFor8PMto9AmCallCheck, setPopupFor8PMto9AmCallCheck] =
    useState(false);
  const [callProgressDetailsLoader, setCallProgressDetailsLoader] =
    useState(true);
  const initiateCallState = useSelector((state) => state.initiateCall);
  const fileListDataState = useSelector((state) => state.initiateCall.fileData);
  const { openPopupForStopCall, stopCallResponse } = useSelector(
    (state) => state.initiateCall
  );
  const globalConfigParamsData = useSelector(
    (state) => state.initiateCall.globalConfigParams
  );
  // console.log("Initatte call state", initiateCallState);
  const todayDate = new Date();

  // console.log("Selected date range", selectedDateRange);
  // console.log(
  //   "curren tplue 20",
  //   moment().add(10, "minutes").utc().format(UTC_DATE_TIME_FORMAT)
  // );
  useEffect(() => {
    let payload = {
      token: userState.token,
      selectedDateRange: selectedDateRange,
    };
    dispatch(getFilesData(payload));
  }, []);

  useEffect(() => {
    // console.log("State changed for file list");
    processFileListDataToTableFormat();
  }, [fileListDataState]);

  useEffect(() => {
    if (fileListDataState && fileListDataState.length > 0) {
      // getFileCallStatusAndUpdateSV();
    }
  }, [fileListDataState]);

  useEffect(() => {
    if (selectedBatchDetails) {
      const itv = setInterval(() => {
        fetchBatchDetailsInInterval(selectedBatchDetails);
      }, 5000);
      setLiveCallFetchInterValId(itv);
    } else {
      clearInterval(liveCallFetchInterValId);
    }
  }, [selectedBatchDetails]);

  useEffect(() => {
    if (initiateCallState.shouldFetchFileData) {
      let updatedStartAndEnddate = {
        startDate: selectedDateRange.startDate,
        endDate: moment().add(10, "minutes").utc().format(UTC_DATE_TIME_FORMAT),
      };
      let payload = {
        token: userState.token,
        selectedDateRange: updatedStartAndEnddate,
      };
      dispatch(getFilesData(payload));
    }
  }, [initiateCallState]);
  // console.log("List files", fileListDataState);

  useEffect(() => {
    // console.log("Selected rage", selectedDateRange);
    let payload = {
      token: userState.token,
      selectedDateRange: selectedDateRange,
    };
    dispatch(getFilesData(payload));
  }, [selectedDateRange]);
  // console.log("Table data initiate call", tableData);

  useEffect(() => {
    if (initiateCallState.isUserVerified && scheduledCallPayloadData) {
      // console.log("User is verified");
      if (scheduledCallPayloadData.isStartCallNowFlow) {
        startCallNowUpdatedPayloadDispatch(scheduledCallPayloadData);
      } else {
        dispatch(updateScheduleCallTimeAction(scheduledCallPayloadData));
        setScheduledCallPayloadData(null);
      }
    }
  }, [initiateCallState.isUserVerified]);

  useEffect(() => {
    // console.log("Calender range selected", selectedButton.isCustom);
    // console.log("calender state", dateFromCalender);
    if (selectedButton.isCustom && dateFromCalender.length > 0) {
      let payload = {
        token: userState.token,
        selectedDateRange: {
          startDate: dateFromCalender[0],
          endDate: dateFromCalender[1],
        },
      };
      dispatch(getFilesData(payload));
    }
  }, [dateFromCalender]);

  //commented for global config data fetch
  // useEffect(() => {
  //   console.log("get global config params");
  //   let payload = {
  //     token: userState.token,
  //   };
  //   dispatch(fetchGlobalConfigsAction(payload))
  // }, []);

  const fetchBatchDetailsInInterval = async (batchData) => {
    console.log("BATCH DATA", batchData);
    let payload = {
      fileId: batchData.id,
    };
    let responseInterFace = await callStatusFromFileId(payload);
    if (
      responseInterFace &&
      responseInterFace.data &&
      responseInterFace.data.total_calls
    ) {
      setBatchDetailsFromInterFace({ ...responseInterFace.data, ...batchData });
      setCallProgressDetailsLoader(false);
    }
  };

  const startCallNowUpdatedPayloadDispatch = (payload) => {
    // console.log("Start call now flow----", payload);
    let finalPayload = payload;
    let callDateandTime = moment()
      .add(1, "minutes")
      .utc()
      .format(UTC_DATE_TIME_FORMAT);

    // console.log("No w time", moment().utc().format(UTC_DATE_TIME_FORMAT));
    // console.log("Date and timr", callDateandTime);
    finalPayload.patchData.scheduledTime = callDateandTime;

    // console.log("Final payload start call now---->", finalPayload);
    dispatch(updateScheduleCallTimeAction(finalPayload));
    setScheduledCallPayloadData(null);
  };

  const buttonText = (data) => {
    let buttondata = {};

    // console.log("Button data", data);

    if (data.status && data.status.isProcessed === true) {
      const currentDateAndTIme = new Date();
      const fileDateAndTime = new Date(data.scheduledTime);
      if (currentDateAndTIme > fileDateAndTime) {
        buttondata.title = "Processed";
        buttondata.color = "#d7e288";
      } else if (currentDateAndTIme < fileDateAndTime) {
        buttondata.title = "Scheduled";
        buttondata.color = "#70d5fa";
      } else {
        buttondata.title = "Call now";
        buttondata.color = "#b5cc18";
      }
    } else if (
      data.status &&
      data.status.isProcessed === false &&
      data.status.error.length > 0
    ) {
      buttondata.title = "Check error";
      buttondata.color = "red";
      buttondata.errorList = data.status.error;
    } else {
      buttondata.title = "Processing";
      buttondata.color = "#ffa500";
    }

    return buttondata;
  };
  const getTimeInIndianStandard = (dateAndTime) => {
    let responseDate = new Date(dateAndTime).toLocaleDateString("en-IN");
    let responseTime = new Date(dateAndTime).toLocaleTimeString("en-IN");
    return responseDate + " " + responseTime;
  };

  const processFileListDataToTableFormat = () => {
    let finalTableData = [];
    for (let i = 0; i < fileListDataState.length; i++) {
      let fileName = fileListDataState[i].fileName;
      let uploadTimestamp = getTimeInIndianStandard(
        fileListDataState[i].createdAt
      );
      let uploaderName = fileListDataState[i].uploderName;
      let workflowName = fileListDataState[i].workflowName;
      let workFlowId = fileListDataState[i].workflowId;
      let isCallStopped = fileListDataState[i].isCallStopped;
      let scheduledTime = fileListDataState[i].scheduledTime
        ? getTimeInIndianStandard(fileListDataState[i].scheduledTime)
        : "Set the call";
      let id = fileListDataState[i]._id;
      let uploadedFileName = fileListDataState[i].uploadedFileName;
      let callInitiation = buttonText(fileListDataState[i]);
      let download = "NA";
      let status = fileListDataState[i].status;
      let callOnGoingStatus = "UNKNOWN";
      let map = {
        fileName,
        uploadTimestamp,
        uploaderName,
        workflowName,
        scheduledTime,
        id,
        uploadedFileName,
        callInitiation,
        download,
        status,
        workFlowId,
        isCallStopped,
        callOnGoingStatus,
      };
      finalTableData.push(map);
    }
    getFileCallStatusAndUpdateSV(finalTableData);
    // setTableData(finalTableData);
  };

  const getFileCallStatusAndUpdateSV = async (tableData) => {
    console.log("Table Data:", tableData);
    // callStatusFromFileId
    for (let i = 0; i < tableData.length; i++) {
      console.log("Table row", tableData[i].id);
      let payload = {
        fileId: tableData[i].id,
      };
      // const res = await callStatusFromFileId(payload);
      // let callStatus = "Unknown";
      // if (res.status === 200) {
      //   console.log("Res:", res);
      //   let resData = res.data;
      //   if (resData.batch_id) {
      //     if (resData.total_calls === resData.completed_calls) {
      //       callStatus = "Completed";
      //     } else if (resData.completed_calls === 0) {
      //       callStatus = "Not Started";
      //     } else if (
      //       resData.pending_calls > 0 &&
      //       resData.total_calls > resData.pending_calls
      //     ) {
      //       callStatus = "On Going";
      //     } else {
      //       callStatus = "Unknown";
      //     }
      //   }
      // }
      const callStatus = "Unknown";
      updateCallStatusInFileList(tableData[i].id, callStatus, tableData);
    }
  };

  const updateCallStatusInFileList = (fileId, callStatus, tableData) => {
    let tempListArr = [...tableData];

    for (let i = 0; i < tempListArr.length; i++) {
      if (tempListArr[i].id === fileId) {
        tempListArr[i].callOnGoingStatus = callStatus;
      }
    }

    console.log("Res data after mod", tempListArr);
    setTableData(tempListArr);
  };

  const onFileChange = (e) => {
    let fileData = e.target.files[0];
    if (fileData.type === "text/csv") {
      setFileDetails({ name: e.target.files[0].name });
      setcsvFile(fileData);
    }
    // setFileName(e.target.files[0].name);
  };
  const getDateFromSelectedValue = (value) => {
    // console.log("Calender value=====>",value)
    let responseDate = new Date(value.date).toLocaleDateString("en-IN");
    console.log("Calender value=====>", responseDate);
    return responseDate;
  };

  const getAndTimeFromSelectedValue = (value) => {
    let responseDate = new Date(value).toLocaleDateString("en-IN");
    let responseTime = new Date(value).toLocaleTimeString("en-IN");
    return responseDate;
  };

  const uploadFileToBlob = async () => {
    let date = new Date();
    date = date.toISOString();
    let fileNameWithoutCSVExt = fileDetails.name.split(".csv");
    console.log("Uploaded file new name", fileNameWithoutCSVExt[0]);
    let fileBaseName = fileNameWithoutCSVExt[0];
    let f_payload = {
      csvFile: csvFile,
      fileDetails: {
        fileName: fileDetails.name,
        fileUpdatedName: fileBaseName + date + ".csv",
        uploaderName: userState.details.userFullName,
        uploaderEmail: userState.details.emailId,
        workflowId: selectedWorkFlow.id,
        workflowName: selectedWorkFlow.name,
      },
      token: userState.token,
    };
    console.log("Upload file details", f_payload);
    dispatch(putCSVFileInBlob(f_payload));
    setShowFileUploadModal(false);
    setFileDetails({
      name: "Not selected",
      updatedName: null,
    });
    setcsvFile(null);
  };

  const submitOtp = () => {
    if (otpValue.length < 6) {
      return;
    } else {
      const payload = {
        data: {
          mobileNo: userState.details.mobileNo,
          otp: otpValue,
        },
        token: userState.token,
      };
      dispatch(verifyOTPWithUser(payload));
    }
  };

  const updateSelectedWorkFlowDetails = (wId) => {
    let selectedFlowData = wfDetails.filter(function (item) {
      return item.id === wId;
    });
    if (selectedFlowData.length > 0) {
      setSelectedWorkFlow(selectedFlowData[0]);
    }
  };

  const getTodaysData = () => {
    setSelectedButton({
      ...selectedButton,
      isToday: true,
      is7days: false,
      is30Days: false,
      isCustom: false,
    });
    setSelectedDateRange({
      ...selectedDateRange,
      startDate: moment()
        .utc()
        .set({ hours: "0", minutes: "0", seconds: "0" })
        .format(UTC_DATE_TIME_FORMAT),
      endDate: moment().utc().format(UTC_DATE_TIME_FORMAT),
    });
    setDateFromCalender(new Date());
  };

  const getSevenDaysData = () => {
    setSelectedButton({
      ...selectedButton,
      is7days: true,
      isToday: false,
      is30Days: false,
      isCustom: false,
    });
    setSelectedDateRange({
      ...selectedDateRange,
      startDate: moment()
        .utc()
        .set({ hours: "0", minutes: "0", seconds: "0" })
        .subtract(6, "days")
        .format(UTC_DATE_TIME_FORMAT),
      endDate: moment().utc().format(UTC_DATE_TIME_FORMAT),
    });
    setDateFromCalender(new Date());
  };

  const getThirtyDaysData = () => {
    setSelectedButton({
      ...selectedButton,
      isToday: false,
      is7days: false,
      is30Days: true,
      isCustom: false,
    });
    setSelectedDateRange({
      ...selectedDateRange,
      startDate: moment()
        .utc()
        .set({ hours: "0", minutes: "0", seconds: "0" })
        .subtract(30, "days")
        .format(UTC_DATE_TIME_FORMAT),
      endDate: moment().utc().format(UTC_DATE_TIME_FORMAT),
    });
    setDateFromCalender(new Date());
  };

  const submitUpdatedScheduleDateTime = () => {
    console.log("updated date and time", scheduleCallTiming);
    console.log("Selected row details", selectedRowTosetCllTime.original);
    console.log("full list", fileListDataState);
    const bodyOfFileDetails = fileListDataState.filter((item) => {
      return item._id === selectedRowTosetCllTime.original.id;
    });
    console.log("body of file details", bodyOfFileDetails[0]);
    let requestPayload = bodyOfFileDetails[0];
    console.log("Request payload", requestPayload);
    // let callDate = moment(scheduleCallTiming.date).format("YYYY-MM-DD");
    // console.log("csll date", callDate);
    // let callDateandTime = callDate + 'T'+scheduleCallTiming.time+':00.000Z'
    // let callDateandTime = callDate + " " + scheduleCallTiming.time;
    // scheduleCallTiming
    let callDateandTime = scheduleCallTiming.dateAndTime;
    console.log("Date and timr", new Date(callDateandTime));
    requestPayload.scheduledTime = new Date(callDateandTime);

    console.log("request payload update cslltimt ====>", requestPayload);

    let updatesPayload = {
      patchData: requestPayload,
      token: userState.token,
      mobileNo: userState.details.mobileNo,
      isStartCallNowFlow: false,
    };
    console.log("payload for start call---", updatesPayload);
    setScheduledCallPayloadData(updatesPayload);
    dispatch(updateScheduleCallTimeAction(updatesPayload));

    // let payload = {
    //   data: {
    //     mobileNo: userState.details.mobileNo,
    //   },
    //   token: userState.token,
    // };
    // dispatch(postOTPToUser(payload));

    //next do patch request here
  };
  function isBetween() {
    // Define the start and end times in 24-hour format
    // const startTime = moment(callBlockStartTime, 'HH:mm').utc();
    // const endTime = moment(callBlockEndTime, 'HH:mm').utc();
    // const currentTime = moment().utc()
    // console.log("start time", startTime)
    // console.log("end time", endTime)
    // console.log("current time", currentTime)
    // // Parse the given time
    // const givenMoment = currentTime;

    // // Check if given time falls within the range (considering the overnight range)

    // // Overnight range (8:45 PM to 8:00 AM next day)
    // const timeCheckRes = givenMoment.isBetween(startTime, endTime.clone().add(1, 'day'), null, '[)');
    // console.log("Teime check res:", timeCheckRes)
    const now = moment.utc();
    console.log("UTC time", now.toISOString());
    const startTime = moment
      .utc()
      .set({ hour: 15, minute: 15, second: 0, millisecond: 0 });
    const endTime = moment
      .utc()
      .add(1, "day")
      .set({ hour: 2, minute: 30, second: 0, millisecond: 0 });

    // return now.isBetween(startTime, endTime, null, '[]');
    return now.isBetween(startTime, endTime, null, "[]");
    // return timeCheckRes
  }
  const onClickStartCallNow = (rowData) => {
    const bodyOfFileDetails = fileListDataState.filter((item) => {
      return item._id === rowData.original.id;
    });
    console.log("body of file details", bodyOfFileDetails[0]);
    let requestPayload = bodyOfFileDetails[0];
    console.log("Request payload", requestPayload);
    let callDate = moment(scheduleCallTiming.date).utc().format("YYYY-MM-DD");
    console.log("csll date", callDate);
    let callDateandTime = moment()
      .add(1, "minutes")
      .utc()
      .format(UTC_DATE_TIME_FORMAT);

    console.log("No w time", moment().utc().format(UTC_DATE_TIME_FORMAT));
    console.log("Date and timr", callDateandTime);
    requestPayload.scheduledTime = callDateandTime;

    console.log("request payload update cslltimt ====>", requestPayload);

    let updatesPayload = {
      patchData: requestPayload,
      token: userState.token,
      mobileNo: userState.details.mobileNo,
      isStartCallNowFlow: true,
    };
    console.log("payload for start call---", updatesPayload);
    // disabling for sometime
    // const isBetween9To8 = isBetween();
    const isBetween9To8 = false;
    console.log("Is time inbetween===>", isBetween9To8);
    if (isBetween9To8) {
      // disabling for sometime
      setPopupFor8PMto9AmCallCheck(true);
    } else {
      setScheduledCallPayloadData(updatesPayload);
      dispatch(updateScheduleCallTimeAction(updatesPayload));
    }

    // let payload = {
    //   data: {
    //     mobileNo: userState.details.mobileNo,
    //   },
    //   token: userState.token,
    // };
    // dispatch(postOTPToUser(payload));
  };
  // console.log("selected workflow details=====>", selectedWorkFlow);

  const onClickEditGlobalConfigSubmit = (configData) => {
    console.log("New config data", configData);
    let payload = {
      configuration: configData,
      createdBy: userState.details.emailId,
    };
    dispatch(updateGlobalConfigsAction(payload));
  };

  const templateFileDownload = async (fileUrl) => {
    let blobData = await getBlobStorageDetails();
    console.log("Blob storage Details->", blobData);
    window.open(fileUrl + blobData.data.sastoken);
  };

  const stopCallForParticularFileAndWorkFlow = (batchId) => {
    const fileId = batchId;
    const workflowId = "";

    let requestPayload = { _id: fileId, workFlowId: "" };
    let updatesPayload = {
      patchData: requestPayload,
      token: userState.token,
      mobileNo: userState.details.mobileNo,
      workflowId: workflowId,
      fileId: fileId,
    };
    setStopCallWorkFlowId(batchId);
    dispatch(updateStopCallAction(updatesPayload));
  };

  const downloadNotReachAbleList = () => {
    let data = [];
    for (let i = 0; i < stopCallResponse.incomplete_calls.length; i++) {
      data.push([stopCallResponse.incomplete_calls[i]]);
    }
    downloadExcel({
      fileName: "Unreachable list",
      sheet: "Unreachablelist",
      tablePayload: {
        header: ["Phone Numbers"],
        body: data,
      },
    });
  };

  const disableFile = () => {
    let requestPayload = { _id: selectedFileToDisable.id };
    let updatesPayload = {
      patchData: requestPayload,
      token: userState.token,
      mobileNo: userState.details.mobileNo,
    };
    console.log("Payload to dispatch", updatesPayload);
    dispatch(disableFileAction(updatesPayload));
  };

  const checkLiveDataForABatch = (selectedFile) => {
    console.log("Selected File", selectedFile);
    setselectedBatchDetails(selectedFile);
    setPopUpForBatchDetails(true);
    setBatchDetailsFromInterFace(null);
    fetchBatchDetailsInInterval(selectedFile);
    setCallProgressDetailsLoader(true);
  };

  const fetchReinitiateCallList = async (batchId) => {
    let payload = {
      batchId: selectedBatchDetails?.id,
      token: userState.token,
    };
    let reinitateList = await exportReinitiateCallList(payload);

    console.log("Reinitate list", reinitateList);

    let exportList = reinitateList.data.reinitiateCallNumbers;

    let data = [];
    for (let i = 0; i < exportList.length; i++) {
      data.push({ phoneNo: exportList[i].mobileNo });
    }
    downloadExcel({
      fileName: "Unreachable list",
      sheet: "Unreachablelist",
      tablePayload: {
        header: ["Phone Numbers"],
        body: data,
      },
    });
  };

  console.log("Batch data : ", batchDetailsFromInterFace, selectedBatchDetails);
  return (
    <div className="analyticsDashboard">
      <HStack m="0 10px 10px 0" className="sbscoHeadingRow">
        <Box w="100%">
          <Heading as="h4" size="md" noOfLines={1}>
            Initiate Call
          </Heading>
        </Box>
      </HStack>
      <HStack spacing="12px" className="NiclInitiateCallWorkflowcard">
        {/* Global config view is just commented */}
        {/* <Box
          className="dbBlock editConfigBlock"
          // m="10px"
          w="40%"
          h="180px"
          bg="white"
          position="relative"
        >
          <EditGlobalConfig globalConfigParamsData={globalConfigParamsData} onClickEditGlobalConfigSubmit={onClickEditGlobalConfigSubmit}/>
        </Box> */}
        <Box className="dbBlock" w="42%" h="150px" bg="white">
          <Heading as="h6" size="xs" m="12px">
            Select workflow
          </Heading>
          <VStack>
            <div className="cardSelectBlock">
              <Select
                onChange={(e) => {
                  updateSelectedWorkFlowDetails(e.target.value);
                }}
                w="100%"
              >
                {wfDetails.map((item, id) => {
                  return <option value={item.id}>{item.name}</option>;
                })}
              </Select>
            </div>
            <Box
              position="relative"
              style={{ width: "100%", marginTop: "0.5em" }}
            >
              <Button
                className="dwnBtn"
                style={{
                  fontWeight: "500",
                  // fontSize: "1vw",
                  backgroundColor: "#2185d0",
                  color: "white",
                  margin: "10px",
                  width: "35%",
                  borderRadius: "6px",
                }}
                rightIcon={<FiDownload />}
                onClick={() => {
                  // templateFileDownload(selectedWorkFlow.templateUrl);
                  window.open(selectedWorkFlow.templateUrl);
                }}
              >
                <p style={{ width: "100%", fontSize: "14px" }}>
                  Download <span>Template</span>
                </p>
              </Button>
              <Button
                className="upBtn"
                onClick={() => {
                  //   fileRef.current.click();
                  setShowFileUploadModal(true);
                }}
                style={{
                  fontWeight: "500",
                  // fontSize: "1vw",
                  backgroundColor: "#2185d0",
                  color: "white",
                  margin: "10px",
                  width: "34%",
                  borderRadius: "6px",
                  float: "right",
                }}
                rightIcon={<FiUpload />}
              >
                <p style={{ width: "100%", fontSize: "14px" }}>
                  Upload <span>User Data</span>
                </p>
              </Button>
            </Box>
          </VStack>
        </Box>
        {/* 
        <Box
          className="dbBlock smBlock"
          m="10px"
          w="10%"
          h="150px"
          bg="white"
          position="relative"
        >
          <Heading as="h6" size="xs" m="14px">
            End Call
          </Heading>
          <Box
            className="ecArea"
            position="relative"
            style={{ width: "70%", marginTop: "15%", marginLeft: "10px" }}
          >
            <Button
              style={{
                width: "100%",
                borderRadius: "5px",
                backgroundColor: "#fbbd08",
                color: "black",
                margin: "2px",
              }}
              onClick={() => {
                dispatch(stopCurrentCallAction());
              }}
            >
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "14px",
                  textTransform: "uppercase",
                  color: "#525252",
                }}
              >
                Stop Current Call
              </p>
            </Button>
          </Box>
        </Box> */}
      </HStack>

      <HStack m="30px 10px 10px 0" className="sbscoHeadingRow">
        <Box w="50%">
          <Heading as="h4" size="md" noOfLines={1}>
            Upload Details
          </Heading>
        </Box>
        <div className="sbscoHeadingRight">
          <Box className="sbscoBtnGroup niclBtnGroupLeft">
            <Button
              onClick={() => {
                getTodaysData();
              }}
              size="sm"
              colorScheme={selectedButton.isToday ? "blue" : "gray"}
              variant={selectedButton.isToday ? "solid" : "outline"}
              border="1px"
            >
              Today
            </Button>
            <Button
              onClick={() => {
                getSevenDaysData();
              }}
              size="sm"
              colorScheme={selectedButton.is7days ? "blue" : "gray"}
              variant={selectedButton.is7days ? "solid" : "outline"}
              border="1px"
            >
              7 Days
            </Button>
            <Button
              onClick={() => {
                getThirtyDaysData();
              }}
              size="sm"
              colorScheme={selectedButton.is30Days ? "blue" : "gray"}
              variant={selectedButton.is30Days ? "solid" : "outline"}
              border="1px"
            >
              30 Days
            </Button>
          </Box>
          <Box className="niclBtnGroupRight">
            <div ref={calenderRef}>
              <VStack className="sbscoBtn">
                <Button
                  onClick={() => {
                    setSelectedButton({
                      ...selectedButton,
                      isToday: false,
                      is7days: false,
                      is30Days: false,
                      isCustom: !selectedButton.isCustom,
                    });
                    setDateFromCalender(new Date());
                  }}
                  size="sm"
                  leftIcon={<FiCalendar />}
                  colorScheme={selectedButton.isCustom ? "blue" : "gray"}
                  variant={selectedButton.isCustom ? "solid" : "outline"}
                  border="1px"
                >
                  {dateFromCalender?.length !== 2
                    ? "Date Range Selection"
                    : `${moment(dateFromCalender[0]).format(
                        "YYYY-MM-DD"
                      )} to ${moment(dateFromCalender[1]).format(
                        "YYYY-MM-DD"
                      )}`}
                </Button>
                {selectedButton.isCustom && dateFromCalender?.length !== 2 ? (
                  <MiniCalendar
                    selectRange={true}
                    pos="absolute"
                    m="20px 0 0 0"
                    border="2px solid black"
                    zIndex="1"
                    transform="scale(0.6)"
                    transformOrigin="top"
                    dateFromCalendar={dateFromCalender}
                    setDateFromCalendar={setDateFromCalender}
                  />
                ) : null}
              </VStack>
            </div>
          </Box>
        </div>
      </HStack>
      <InitiateCallTable
        title={""}
        columnsData={columnName}
        tableData={tableData}
        isEvening={false}
        onClickStartCallNow={onClickStartCallNow}
        setShowEditCallTimeModal={setShowEditCallTimeModal}
        setScheduletimeDetails={setselectedRowTosetCllTime}
        stopCallForParticularFileAndWorkFlow={
          stopCallForParticularFileAndWorkFlow
        }
        setPopupForDisableFile={setPopupForDisableFile}
        setSelectedFileToDisable={setSelectedFileToDisable}
        // updateAnalyticsValue={updateAnalyticsValue}
        checkLiveDataForABatch={checkLiveDataForABatch}
        setModalCallReInitiation={setModalCallReInitiation}
      />
      <Modal
        isOpen={showFileUploadModal}
        onClose={() => {
          onClose();
          setShowFileUploadModal(false);
        }}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Upload Data</ModalHeader>

          <ModalBody style={{ height: "40em" }}>
            <p>Workflow Id - {selectedWorkFlow.id}</p>

            <p>Workflow name - {selectedWorkFlow.name}</p>
            <p>File</p>
            <InputGroup size="sm">
              <Text
                style={{ width: "100%", border: "0.7px solid #e2e8f0" }}
                fontSize="md"
              >
                {fileDetails.name}
              </Text>
              {/* <Input value={fileDetails.name} /> */}
              <Button
                onClick={() => {
                  fileRef.current.click();
                }}
                size="sm"
                // colorScheme={selectedButton.is30Days ? "blue" : "gray"}
                // variant={selectedButton.is30Days ? "solid" : "outline"}
                border="1px"
                style={{ borderRadius: "1px" }}
              >
                Browse
              </Button>
            </InputGroup>
            <p>*Please note application supports only CSV files</p>

            <input
              ref={fileRef}
              style={{ display: "none" }}
              onChange={(e) => {
                onFileChange(e);
              }}
              type="file"
              accept=".csv"
            ></input>
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={() => {
                console.log("upload clicked");
                if (csvFile) {
                  uploadFileToBlob();
                } else {
                  console.log("File not selected");
                }
              }}
            >
              Upload
            </Button>
            <Button
              onClick={() => {
                onClose();
                setShowFileUploadModal(false);
                setFileDetails({
                  name: "Not selected",
                  updatedName: null,
                });
                setcsvFile(null);
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={initiateCallState.showModalToEnterOTP}
        // isOpen={true}
        onClose={() => {
          onClose();
          // setShowOTPInsertModal(false);
          dispatch(closeOTPModal());
        }}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Enter OTP </ModalHeader>

          <ModalBody style={{ height: "40em" }}>
            <HStack>
              <PinInput
                otp={true}
                onChange={(e) => {
                  console.log("val", e);
                  setOTPValue(e);
                }}
              >
                <PinInputField />
                <PinInputField />
                <PinInputField />
                <PinInputField />
                <PinInputField />
                <PinInputField />
              </PinInput>
            </HStack>
            <p>
              *Please note otp will be expired in 10 minutes. If you have not
              received any OTP please cancel and retry
            </p>
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={() => {
                submitOtp();
              }}
            >
              Submit
            </Button>
            <Button
              onClick={() => {
                onClose();
                // setShowOTPInsertModal(false);
                dispatch(closeOTPModal());
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        style={{ zIndex: "100px", height: "40em" }}
        // isOpen={}
        isOpen={showEditCallTimeModal}
        onClose={() => {
          // setShowEditCallTimeModal(false);
        }}
      >
        {/* <ModalOverlay /> */}
        <ModalContent>
          <ModalHeader>Pick Date and time</ModalHeader>

          <ModalBody>
            <div style={{ marginTop: "0em" }}>
              <HStack>
                <Text style={{ width: "10%" }}>
                  <FiGlobe color="#2185d0" size={25} />
                </Text>
                <Text style={{ width: "20%" }}>Asia/Delhi</Text>
                <div style={{ width: "40%" }}>
                  {/* <Select
                    placeholder="Select Time"
                    size="md"
                    onChange={(e) => {
                      console.log("event value", e.target.value)
                      setScheduleCallTiming((state)=>{return {...state,time: e.target.value}})
                    }
                    }
                  >
                    {s_time.map((item, id) => {
                      return <option value={item.valueUTC}>{item.title}</option>;
                    })}
                  </Select> */}
                  {/* controlled input */}

                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["TimePicker"]}>
                      <TimePicker
                        label="Controlled picker"
                        value={scheduleCallTiming.time}
                        // onChange={(newValue) => setValue(newValue)}
                      />
                    </DemoContainer>
                  </LocalizationProvider> */}

                  {/* <TimeInput style={{zIndex: "2000000"}}
                    mode="12h"
                    // value={this.state.time}
                    // onChange={(time) => this.handleChange(time)}
                  /> */}
                  {/* <TimePicker 
                  style={{zIndex: "2000000px"}}
                    // onChange={onChange}
                    defaultOpenValue={dayjs("00:00:00", "HH:mm:ss")}
                  /> */}
                  {/* <Input
                    placeholder="Select Date and Time"
                    size="md"
                    type="datetime-local"
                  /> */}
                </div>
              </HStack>
            </div>
            <div style={{ marginTop: "2em" }}>
              <HStack>
                <Text style={{ width: "10%" }}>
                  <FiCalendar size={25} />
                </Text>
                <Text tyle={{ width: "20%" }}>Select Date and time: </Text>
                <div style={{ marginLeft: "3em" }}>
                  <VStack className="sbscoBtn">
                    {/* <Button
                      onClick={() => {
                        setOpenMiniCalender(!openMiniCalender);
                      }}
                      size="sm"
                      leftIcon={<FiCalendar />}
                      colorScheme={"gray"}
                      variant={"outline"}
                      border="1px"
                      style={{ height: "3em", width: "100%" }}
                    >
                      <p>{getDateFromSelectedValue(scheduleCallTiming)}</p>
                    </Button> */}
                    <Input
                      value={scheduleCallTiming.dateAndTime}
                      style={{ height: "3em", width: "100%" }}
                      placeholder="Select Date and Time"
                      size="md"
                      type="datetime-local"
                      onChange={(e) => {
                        console.log("Evt", e.target.value);
                        setScheduleCallTiming((state) => {
                          return { ...state, dateAndTime: e.target.value };
                        });
                        //   props.setOpenMiniCalender((state) => !state);
                      }}
                      // maxDate={new Date()}
                    />
                  </VStack>
                </div>
              </HStack>
            </div>
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={() => {
                // submitOtp();
                submitUpdatedScheduleDateTime();
                setShowEditCallTimeModal(false);
              }}
            >
              Submit
            </Button>
            <Button
              onClick={() => {
                // onClose();
                // setShowOTPInsertModal(false);
                // dispatch(closeOTPModal());
                setShowEditCallTimeModal(false);
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        style={{ zIndex: "100px", height: "40em" }}
        // isOpen={}
        isOpen={openPopupForStopCall}
        onClose={() => {
          // setShowEditCallTimeModal(false);
        }}
      >
        {/* <ModalOverlay /> */}
        <ModalContent>
          <ModalHeader>Stop Call Status</ModalHeader>

          <ModalBody>
            Call Stopped For Batch = {stopCallWorkFlowId}
            <br></br>
            Call Stopped for users number ={" "}
            {stopCallResponse &&
            stopCallResponse.incomplete_calls &&
            stopCallResponse.incomplete_calls.length
              ? stopCallResponse.incomplete_calls.length
              : 0}
            <br></br>
            {/* {stopCallResponse &&
              stopCallResponse.incomplete_calls &&
              stopCallResponse.incomplete_calls.map((item, id) => {
                return <p>{item}</p>;
              })} */}
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={() => {
                // submitOtp();
                downloadNotReachAbleList();
              }}
            >
              Download list
            </Button>
            <Button
              onClick={() => {
                dispatch(setModalForStopCallAction({}));
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal
        style={{ zIndex: "100px", height: "40em" }}
        // isOpen={}
        isOpen={popupForDisableFile}
        onClose={() => {
          // setShowEditCallTimeModal(false);
          setPopupForDisableFile(false);
        }}
      >
        <ModalContent>
          <ModalHeader>Warning</ModalHeader>

          <ModalBody>
            Are you sure you want to disable the File <br></br>
            Name : {selectedFileToDisable?.fileName}
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={() => {
                // submitOtp();
                // downloadNotReachAbleList()
                disableFile();
              }}
            >
              Yes
            </Button>
            <Button
              onClick={() => {
                setPopupForDisableFile(false);
                //  dispatch(setModalForStopCallAction({}))
              }}
            >
              No
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        style={{ zIndex: "100px", height: "40em" }}
        // isOpen={}
        isOpen={popupForBatchDetails}
        onClose={() => {
          // setShowEditCallTimeModal(false);
          setselectedBatchDetails(null);
          setPopUpForBatchDetails(false);
        }}
      >
        <ModalContent className="checkBatchModal">
          <ModalHeader className="modalTitle">
            <p>Batch Details</p> Batch Id :{" "}
            {batchDetailsFromInterFace?.batch_id}
          </ModalHeader>

          <ModalBody>
            {callProgressDetailsLoader ? (
              <ClipLoader size={55} color="#2185d0" />
            ) : (
              <HStack>
                <Box className="checkBatchModalBody">
                  <p>
                    <label>File Name</label> -{" "}
                    {batchDetailsFromInterFace?.fileName}
                  </p>
                  <p>
                    <label>Workflow</label> -{" "}
                    {batchDetailsFromInterFace?.workflowName}
                  </p>
                  <p>
                    <label>Call Status</label> -{" "}
                    {batchDetailsFromInterFace?.callOnGoingStatus}
                  </p>
                  <br></br>

                  {/* {batchDetailsFromInterFace &&
                batchDetailsFromInterFace.callOnGoingStatus === "On Going" ? ( */}
                  <div>
                    <p>
                      <label>Total Calls</label> -{" "}
                      {batchDetailsFromInterFace?.total_calls}
                    </p>
                    <p>
                      <label>Completed Calls</label> -{" "}
                      {batchDetailsFromInterFace?.completed_calls}
                    </p>
                    <p>
                      <label>Pending Calls</label> -{" "}
                      {batchDetailsFromInterFace?.pending_calls}
                    </p>
                    <br></br>
                    <br></br>
                    <div>
                      {batchDetailsFromInterFace?.isCallStopped ||
                      batchDetailsFromInterFace?.pending_calls === 0 ? null : (
                        <Button
                          onClick={() =>
                            stopCallForParticularFileAndWorkFlow(
                              batchDetailsFromInterFace?.batch_id
                            )
                          }
                          style={{ backgroundColor: "#f59732" }}
                        >
                          Stop Ongoing Call
                        </Button>
                      )}
                    </div>
                  </div>
                  {/* ) : null} */}
                </Box>
                <div className="radialChart" style={{ marginLeft: "2em" }}>
                  <RadialChart
                    data={[
                      {
                        angle:
                          (batchDetailsFromInterFace?.completed_calls /
                            batchDetailsFromInterFace?.total_calls) *
                          360,
                        innerRadius: 0.88,
                        color: "#0079EA",
                      },
                      {
                        angle:
                          (batchDetailsFromInterFace?.pending_calls /
                            batchDetailsFromInterFace?.total_calls) *
                          360,
                        innerRadius: 0.88,
                        color: "#7EBAF3",
                      },
                    ]}
                    width={160}
                    height={160}
                    colorType="literal"
                  />
                  <div className="radialText">
                    <p>Total calls</p>
                    <h4>{batchDetailsFromInterFace?.total_calls}</h4>
                  </div>
                </div>
              </HStack>
            )}
            <br></br>
            <Button
              onClick={() =>
                fetchReinitiateCallList(batchDetailsFromInterFace?.batch_id)
              }
              style={{ fontSize: "10px", width: "20em" }}
            >
              Export unanswered + incomplete calls
            </Button>
          </ModalBody>

          <ModalFooter>
            <Button
              onClick={() => {
                setPopUpForBatchDetails(false);
                setselectedBatchDetails(null);
                //  dispatch(setModalForStopCallAction({}))
              }}
            >
              Ok
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        style={{ zIndex: "100px", height: "40em" }}
        // isOpen={}
        isOpen={popupFor8PMto9AmCallCheck}
        onClose={() => {
          // setShowEditCallTimeModal(false);
          setPopupFor8PMto9AmCallCheck(false);
        }}
      >
        <ModalContent>
          <ModalHeader>Warning</ModalHeader>

          <ModalBody>
            Call cannot be initiated between 8:45 PM to morning 8 AM <br></br>
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={() => {
                setPopupFor8PMto9AmCallCheck(false);
              }}
            >
              Ok
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {modalCallReinitiation && (
        <>
          <Modal
            isOpen={modalCallReinitiation}
            onClose={() => {
              setModalCallReInitiation(false);
            }}
            size="2xl"
            isCentered
          >
            <ModalOverlay />
            <ModalContent
              className="callInfoContents"
              borderRadius="md"
              boxShadow="xl"
              bg="white"
            >
              <ModalHeader
                fontWeight="bold"
                fontSize="lg"
                borderBottom="1px solid #E2E8F0"
              >
                Call Reinitiation
              </ModalHeader>

              <ModalBody pt={6} pb={4}>
                {/* Timezone Row */}
                <HStack spacing={6} mb={6}>
                  <Box w="10%">
                    <FiGlobe color="#2185d0" size={24} />
                  </Box>
                  <Text w="20%" fontWeight="medium" color="gray.700">
                    Asia/Delhi
                  </Text>
                  <Box w="70%">
                    {/* Placeholder for Select or TimePicker */}
                    <div>
                      {/* <Select
                    placeholder="Select Time"
                    size="md"
                    onChange={(e) => {
                      console.log("event value", e.target.value)
                      setScheduleCallTiming((state)=>{return {...state,time: e.target.value}})
                    }
                    }
                  >
                    {s_time.map((item, id) => {
                      return <option value={item.valueUTC}>{item.title}</option>;
                    })}
                  </Select> */}
                      {/* controlled input */}

                      {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["TimePicker"]}>
                      <TimePicker
                        label="Controlled picker"
                        value={scheduleCallTiming.time}
                        // onChange={(newValue) => setValue(newValue)}
                      />
                    </DemoContainer>
                  </LocalizationProvider> */}

                      {/* <TimeInput style={{zIndex: "2000000"}}
                    mode="12h"
                    // value={this.state.time}
                    // onChange={(time) => this.handleChange(time)}
                  /> */}
                      {/* <TimePicker 
                  style={{zIndex: "2000000px"}}
                    // onChange={onChange}
                    defaultOpenValue={dayjs("00:00:00", "HH:mm:ss")}
                  /> */}
                      {/* <Input
                    placeholder="Select Date and Time"
                    size="md"
                    type="datetime-local"
                  /> */}
                    </div>
                  </Box>
                </HStack>

                {/* Date & Time Row */}
                <HStack spacing={6}>
                  <Box w="10%">
                    <FiCalendar size={24} color="#2185d0" />
                  </Box>
                  <Text w="20%" fontWeight="medium" color="gray.700">
                    Select Date and Time:
                  </Text>
                  <Box w="70%">
                    {/* <Button
                      onClick={() => {
                        setOpenMiniCalender(!openMiniCalender);
                      }}
                      size="sm"
                      leftIcon={<FiCalendar />}
                      colorScheme={"gray"}
                      variant={"outline"}
                      border="1px"
                      style={{ height: "3em", width: "100%" }}
                    >
                      <p>{getDateFromSelectedValue(scheduleCallTiming)}</p>
                    </Button> */}
                    <Input
                      value={scheduleCallTiming.dateAndTime}
                      placeholder="Select Date and Time"
                      type="datetime-local"
                      size="md"
                      height="3em"
                      onChange={(e) => {
                        console.log("Evt", e.target.value);
                        // setScheduleCallTiming((state) => {
                        //   return { ...state, dateAndTime: e.target.value };
                        // });
                        //   props.setOpenMiniCalender((state) => !state);
                      }}
                      // maxDate={new Date()}
                      backgroundColor="#F7FAFC"
                      borderColor="#E2E8F0"
                      _hover={{ borderColor: "#CBD5E0" }}
                      _focus={{ borderColor: "#9eceff", boxShadow: "0 0 0 1px #9eceff" }}
                      borderRadius="md"
                      color="gray.800"
                    />
                  </Box>
                </HStack>

                {/* Customer Info Row */}
                <HStack spacing={6} mt={6}>
                  <Box w="10%">
                    <FiUser size={24} color="#2185d0" />
                  </Box>
                  <Text w="20%" fontWeight="medium" color="gray.700">
                    Customer Name
                  </Text>
                  <Box w="70%">
                    <Text fontWeight="bold" color="gray.800">
                      Enter Customer Name Here
                    </Text>
                  </Box>
                </HStack>
              </ModalBody>

              <ModalFooter borderTop="1px solid #E2E8F0" mt={4}>
                <Button
                  onClick={() => {
                    setModalCallReInitiation(false);
                  }}
                  variant="outline"
                  borderColor="#BDBDBD"
                  color="gray.700"
                  _hover={{ bg: "#f1f1f1" }}
                  borderRadius="lg"
                  size="sm"
                  p={4}
                  boxShadow="sm"
                >
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </>
      )}
    </div>
  );
}
